module.exports = __webpack_public_path__ + "img/报名流程.fe4ca845.png";